module.exports = azureAd;